import { useEffect, useRef } from "react";

function HTMLPreview({ content }) {
    const iframeRef = useRef(null);

    useEffect(() => {
        const iframeDoc = iframeRef.current.contentDocument || iframeRef.current.contentWindow.document;
        iframeDoc.open();
        iframeDoc.write(content);
        iframeDoc.close();
    }, [content]);

    return <iframe id="html-preview-iframe" ref={iframeRef} style={{ width: '100%', height: '100%' }} />;
}

export default HTMLPreview;